import React, { useEffect, useState } from "react";
import api from "@/lib/upr-api";
import DOMPurify from "dompurify";
import { RICH_TEXT_SANITIZE } from "@/lib/rich-text";

function toEmbed(url) {
  if (!url) return "";
  const yt = url.match(/youtube\.com\/watch\?v=([^&]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const ytShort = url.match(/youtu\.be\/([^?]+)/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;
  return url;
}

export default function Video() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos").then(({ data }) => setVideos(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-6 md:px-12 lg:px-16 py-12 md:py-20" data-testid="video-page">
      <div className="upr-eyebrow mb-6"><span className="upr-divider"/>Moving Image</div>
      <h1 className="font-heading font-black tracking-tighter leading-[0.88] text-5xl md:text-7xl lg:text-8xl" style={{ letterSpacing: "-0.035em" }}>
        Video.
      </h1>
      <p className="mt-5 max-w-xl text-base md:text-lg" style={{ color: "var(--upr-muted)" }}>
        Promo clips, live sessions and visual experiments from the Universo Positivo roster.
      </p>

      {loading ? (
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          {[...Array(2)].map((_, i) => <div key={i} className="aspect-video animate-pulse" style={{ background: "var(--upr-surface)" }} />)}
        </div>
      ) : videos.length === 0 ? (
        <div className="mt-12 text-sm" style={{ color: "var(--upr-muted)" }}>No videos posted yet.</div>
      ) : (
        <div className="mt-14 grid md:grid-cols-2 gap-10 md:gap-14" data-testid="videos-grid">
          {videos.map((v) => (
            <article key={v.id} data-testid={`video-card-${v.id}`}>
              <div className="aspect-video w-full" style={{ border: "1px solid var(--upr-border)" }}>
                <iframe
                  title={v.title}
                  src={toEmbed(v.youtube_url)}
                  className="w-full h-full"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="pt-4">
                <div className="upr-eyebrow" style={{ fontSize: "0.62rem" }}>{v.artist_name || "Video"}</div>
                <h3 className="font-heading font-extrabold text-xl md:text-2xl leading-tight mt-1" style={{ letterSpacing: "-0.02em" }}>{v.title}</h3>
                {v.description && (
                  <div
                    className="mt-2 text-sm upr-rich-teaser"
                    style={{ color: "var(--upr-muted)" }}
                    data-testid={`video-description-${v.id}`}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(v.description, RICH_TEXT_SANITIZE) }}
                  />
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
